/**
 * form-course-booking.js starts
 * Created by mac on 16.10.2018.
 */

$(function () {

    /*Обновление лимитов*/
    $(document).on('change', '[name="course-date"]', function (e) {
        var limit = $(e.currentTarget).find('option:selected').data('limit');

        var limitHolder = document.getElementById('booking-limit');
        if (limitHolder)
            limitHolder.innerText = limit + ' ' + Wf.numerals(limit, ['место', 'места', 'мест']);
    });

    /*Блокировка неактивных полей*/
    var $tabLink = $('.tab-link, .form-tab');
    $tabLink.on('hidden.bs.tab', function (e) {
        var tab = $(e.target).attr('href');
        $(tab).find('fieldset').prop('disabled', true);
    });

    $tabLink.on('shown.bs.tab', function (e) {
        var tab = $(e.target).attr('href');
        $(tab).find('fieldset').prop('disabled', false);
    });


    var $courseForm = $('#course-form form'),
        $extraOptions = $courseForm.find('.extra-option');

    /*Пересчёт цен*/
    $extraOptions.on('change', function () {
        var data = {
            form: $courseForm,
            priceInput: '.total-sum-input',
            priceVisual: '.total-sum-visual',
            extraOptions: '.extra-option'
        }
        countCourseBooking(data);
    });

    $courseForm.on('submit', function (e) {
        if ($(this).is('.no-ajax')) {
            return;
        }
        else {
            e.preventDefault();
            var $f = $(this);
            var formAction = $f.attr('action'),
                formMethod = 'POST',
                formData = $f.serialize();

            $.ajax({
                url: formAction,
                method: formMethod,
                data: formData,
                success: function (res) {
                    Wf.toggleForm($f);
                },
                error: function (err) {
                    console.log(err);
                }
            });
        }
    });

});

/**countCourseBooking - подсчёт цены курса (зависит от выбранных допов)
 * @paran {object} data.form - jquery-объект с формой, в которой производить вычисления
 * @param {string} data.priceInput - селектор инпута с суммой к оплате
 * @param {string} data.priceVisual - селектор визуального отображения суммы
 * @param {string} data.extraOptions - селектор инпутов с дополнительными курсами
 * */
function countCourseBooking(data) {
    if (typeof data === "undefined")
        return false;
    if (typeof data.form === "undefined")
        return false;

    var $f = data.form,
        $priceInput = $f.find(data.priceInput),
        $priceVisual = $f.find(data.priceVisual),
        $extraOptions = $f.find(data.extraOptions + ':checked');
    /*todo:переделать пересчет скидки на проценты*/
    var prices = $priceInput.data('prices').split(','),
        totalSelected = $extraOptions.length,
        totalPrice = prices[totalSelected];

    if (totalPrice){
        $priceInput.val(totalPrice);
        $priceVisual.text(totalPrice);
    }

}

/* form-course-booking.js ends */